module.exports = __webpack_public_path__ + "static/the-hard-thing-about-hard-things-74f0fe7e2fa0f2ad8da7ffd23f1bd480.jpg";